<script>
import { createMeilisearchClient } from "../../../api/meilisearch";
import mixin from "./mixin"

export default {
    props: { ...mixin.props },
    data() {
        return { 
            results: [],
            highlighted: null,
            typing: "",
            client: null
        }
    },
    methods: {
        async search(typing = this.typing) {
            if (this.highlighted) this.setHighlighted(null);
            if (this.value) this.setSelectedResult(null);

            if (typing === "") return this.hideResults();
            
            const { hits } = await this.client.search(this.index, typing, this.searchParameters);
            
            this.results = hits;

            return this;
        },
        reset() {
            if (!this.resetable) return this;
            
            return this.setTyping("")
                .hideResults()
        },
        hideResults() {
            this.results = [];

            return this;
        },
        setTyping(value) {
            this.typing = value;

            return this;
        },
        setSelectedResult(result) {
            this.$emit('input', result);

            return this;
        },
        setSelectedResultAndTyping(result) {
            return this.setSelectedResult(result)
                .setTyping(this.displayBy(result) ?? "");
        },
        selectResult(result) {
            return this.setSelectedResultAndTyping(result)
                .hideResults();
        },
        onTypingInput({ target: { value } }) {
            this.typing = value;
            this.search();
        },
        onTypingKeydown({ keyCode  }) {
            switch (keyCode) {
                case 27:
                    return this.onTypingEscape();
                case 13:
                    return this.onTypingEnter();
                case 38:
                    return this.onTypingArrowUp();
                case 40:
                    return this.onTypingArrowDown();
                default:
                    return;
            }
        },
        onTypingEscape() {
            this.reset();
        },
        onTypingEnter() {
            if (!this.highlighted) return;
            this.selectResult(this.highlighted);
        },
        onTypingArrowDown() {
            this.onArrow(0, this.countResults - 1, 1);
        },
        onTypingArrowUp() {
            this.onArrow(this.countResults -1, 0, -1);
        },
        onArrow(default_index, index_leading_to_default, step)
        {
            if (!this.havingResults) return;

            if (!this.highlighted) return this.setHighlighted(this.results[default_index]);

            const current_index = this.results.findIndex(result => this.trackBy(result) === this.highlightedTracking);

            if (current_index === index_leading_to_default) return this.setHighlighted(this.results[default_index]);

            this.setHighlighted(this.results[current_index + step]);
        },
        isHighlighted(result) {
            return this.highlightedTracking === this.trackBy(result);
        },
        setHighlighted(result) {
            this.highlighted = result;

            return this;
        },
        setTypingAtStart() {
            if (!this.value) return;

            this.typing = this.displayBy(this.value);
        }
    },
    computed: {
        countResults() {
            return this.results.length;
        },
        havingResults() {
            return !!this.countResults;
        },
        resetable() {
            return !!(!this.value && this.typing);
        },
        highlightedTracking() {
            return this.highlighted && this.trackBy(this.highlighted);
        }
    },
    render() {
        return this.$scopedSlots.default({
            results: {
                all: this.results,
                highlighted: this.highlighted,
                hide: this.hideResults,
                select: this.selectResult,
                isHighlighted: this.isHighlighted,
                having: this.havingResults
            },
            typing: {
                bind: { value: this.typing },
                on: {
                    input: this.onTypingInput,
                    keydown: this.onTypingKeydown
                },
                set: this.setTyping
            },
            search: this.search,
            reset: this.reset,
        });
    },
    created() {
        this.setTypingAtStart();
        this.client = createMeilisearchClient();
    }
}
</script>